import { X, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDemoMode } from "@/hooks/useDemoMode";

export function DemoBanner() {
  const { isDemoMode, exitDemoMode } = useDemoMode();

  if (!isDemoMode) return null;

  return (
    <div className="sticky top-0 z-50 bg-amber-100 border-b border-amber-200 px-4 py-2">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-amber-600" />
          <span className="text-sm font-medium text-amber-800">
            You're viewing demo data
          </span>
          <span className="text-sm text-amber-600 hidden sm:inline">
            — This is sample data to help you explore the platform
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={exitDemoMode}
          className="text-amber-700 hover:text-amber-900 hover:bg-amber-200 gap-1"
        >
          <span className="hidden sm:inline">Exit Demo</span>
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
